import { hasPlugin as hasPluginInPlugins } from './../wix-ricos-common';
import type { RichContentEditorProps } from './../ricos-common';
import { VERTICAL_EMBED_TYPE } from './../ricos-content';
import type { ViewerPlugin } from './../ricos-types';

import { verticalEmbedViewerStrategy } from './verticalEmbedViewerStrategy/verticalEmbedViewerStrategy';

export const runViewerStrategies = (
  plugins: ViewerPlugin[] | undefined,
  baseUrl?: string,
  previewMode?: boolean
): RichContentEditorProps => {
  const hasPlugin = (pluginType: string) => hasPluginInPlugins(pluginType, plugins);
  return baseUrl && hasPlugin(VERTICAL_EMBED_TYPE)
    ? verticalEmbedViewerStrategy(baseUrl, previewMode)
    : { config: {} };
};
